var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"webinars"},[_c('weebly-iframe',{attrs:{"path":_vm.path,"root-path":_vm.rootPath,"weebly-root-path":'/webinars.html',"event-data":_vm.eventData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }